var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.header,style:({
    backgroundColor:
      _vm.headerParallaxRate === 0
        ? 'transparent'
        : ("rgba(255, 255, 255, " + _vm.headerParallaxRate + ")"),
  })},[_c('x-icon',{class:_vm._.back,style:({
      color: _vm.goodsData.isOff
        ? 'black'
        : _vm.headerParallaxRate === 0
        ? 'white'
        : ("rgba(0, 0, 0, " + _vm.headerParallaxRate + ")"),
      backgroundColor: _vm.goodsData.isOff
        ? 'transparent'
        : _vm.headerParallaxRate === 0
        ? 'rgba(0, 0, 0, 0.6)'
        : 'transparent',
    }),attrs:{"name":"back"},on:{"click":_vm.handleBackClick}}),(
      !_vm.goodsData.isOff &&
      !_vm.$globalModel.state.isCouponMall &&
      !_vm.goodsData.isExchange
    )?_c('x-icon',{directives:[{name:"track",rawName:"v-track",value:({
      name: '分享按钮',
      id: '27417243-f4d1-405d-98ec-6fb65d513466',
      newId: 'FenXiang',
      extra: {
        commodity_id: _vm.goodsData.commodityId,
        commodity_name: _vm.goodsData.commodityTitle,
        store_id: _vm.goodsData.merchantId,
        store_name: _vm.goodsData.merchantName,
      },
    }),expression:"{\n      name: '分享按钮',\n      id: '27417243-f4d1-405d-98ec-6fb65d513466',\n      newId: 'FenXiang',\n      extra: {\n        commodity_id: goodsData.commodityId,\n        commodity_name: goodsData.commodityTitle,\n        store_id: goodsData.merchantId,\n        store_name: goodsData.merchantName,\n      },\n    }"}],class:_vm._.shareIcon,style:({
      color:
        _vm.headerParallaxRate === 0
          ? 'white'
          : ("rgba(0, 0, 0, " + _vm.headerParallaxRate + ")"),
      backgroundColor:
        _vm.headerParallaxRate === 0 ? 'rgba(0, 0, 0, 0.6)' : 'transparent',
    }),attrs:{"name":"share"},on:{"click":_vm.goodsData.share}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }